import { workflowStructurePresentationFlag } from '@/_data/developmentFlags';
import type { WorkflowStructurePresentationFlag } from '@/_data/developmentFlags';
import type { AuthoredBaseConfig, BaseConfig } from '@/workflow/_contract/config';

export function assertAuthoredWorkflowStructure(config: Partial<AuthoredBaseConfig>): void {
    const domain = config.domainPresentation;
    if (domain?.entities?.macroSteps?.tori && 'enabled' in domain.entities.macroSteps.tori) {
        throw new Error('Flag-owned config field: domainPresentation.entities.macroSteps.tori.enabled');
    }
    if (domain?.connectors?.macroStep && 'enabled' in domain.connectors.macroStep) {
        throw new Error('Flag-owned config field: domainPresentation.connectors.macroStep.enabled');
    }
}

export function buildWorkflowConfig(
    config: AuthoredBaseConfig,
    flag: WorkflowStructurePresentationFlag = workflowStructurePresentationFlag,
): BaseConfig {
    assertAuthoredWorkflowStructure(config);
    const domain = config.domainPresentation;
    return {
        ...config,
        domainPresentation: {
            ...domain,
            entities: { ...domain.entities, macroSteps: { ...domain.entities.macroSteps,
                tori: { ...domain.entities.macroSteps.tori, enabled: flag === 'macro-step-tori' },
            } },
            connectors: { ...domain.connectors,
                macroStep: { ...domain.connectors.macroStep, enabled: false },
            },
        },
    };
}
